import type { ProjectRole } from '@overlayqa/shared';
import { DesignTokenSources } from '../DesignTokenSources';
import { IgnoredViolationsSection } from './IgnoredViolationsSection';

interface AuditsTabProps {
  project: { id: string; role?: ProjectRole | null };
}

/**
 * The Audits tab: what an audit checks against (Design Tokens) and what it
 * skips (ignored accessibility violations). Emily, 2026-09-17: "we should prob
 * merge design tokens and and accessibility".
 */
export function AuditsTab({ project }: AuditsTabProps) {
  // Mirrors requireProjectWrite on POST /projects/:id/token-sources, which
  // refuses `!role || role === 'viewer'`, so the upload never renders as a
  // control that can only 403.
  const canWriteProject = project.role != null && project.role !== 'viewer';

  return (
    <div className="px-6 pt-4 pb-5 space-y-6">
      {canWriteProject && (
        <section aria-labelledby="design-tokens-heading">
          <h3 id="design-tokens-heading" className="section-label mb-3">Design Tokens</h3>
          <DesignTokenSources projectId={project.id} />
        </section>
      )}
      <IgnoredViolationsSection projectId={project.id} />
    </div>
  );
}
